import React from 'react';
import FactoryRouter from './FactoryManagementRouter';

export default function FactoryManagementPage() {
  return <FactoryRouter />;
}
